import _objectSpread from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  class: "select-all-container"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  class: "select-all"
};
var _hoisted_4 = {
  key: 0,
  class: "price"
};
var _hoisted_5 = {
  class: "price-block"
};
var _hoisted_6 = {
  class: "price-total"
};
var _hoisted_7 = {
  class: "price-icon"
};
var _hoisted_8 = {
  class: "price-int"
};
var _hoisted_9 = {
  class: "price-decimal"
};
var _hoisted_10 = {
  key: 0
};
var _hoisted_11 = {
  key: 1
};
var _hoisted_12 = ["src"];
var _hoisted_13 = {
  style: {
    "margin-right": "8px",
    "margin-left": "5px"
  }
};
var _hoisted_14 = {
  style: {
    "display": "flex"
  }
};
var _hoisted_15 = {
  class: "number fixed-width"
};
var _hoisted_16 = {
  key: 1
};
var _hoisted_17 = ["disabled"];
var _hoisted_18 = {
  class: "number fixed-width"
};
import { ref } from 'vue';
import store from '@/store';
import { showToast } from 'vant';
import { useI18n } from 'vue-i18n';
import cartUtils from '../cartUtils';
import { useRouter } from 'vue-router';
import { Bridge } from '@/utils/bridge';
import { useLess } from '@/models/hooks';
import imageLink from '@/configs/imageLink';
import OutOfStockPopup from '@/components/popup/OutOfStockPopup.vue';
import { priceSplice, setCheckoutList, isLoginAuthenticated, setCartDataChangeStatus } from '@/utils/common';
import { clickEvents } from '@/configs/awsRumConfig';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
export default {
  __name: 'CheckoutNavigation',
  setup(__props, {
    expose: __expose
  }) {
    useLess('views/cart/components/CheckoutNavigation.less');
    var UPARROW = imageLink.UPARROW,
      SELECTED = imageLink.SELECTED,
      NOT_SELECTED = imageLink.NOT_SELECTED,
      SUCCESS_ICON_IMAGE_URL = imageLink.SUCCESS_ICON_IMAGE_URL;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var router = useRouter();
    var totalPricesRef = ref(null);
    // Control variables for product out of stock pop ups
    var outOfStockPopConfig = ref({
      isShow: false,
      asinList: []
    });
    var _cartUtils$cartState = cartUtils.cartState,
      selectAll = _cartUtils$cartState.selectAll,
      cartData = _cartUtils$cartState.cartData,
      activeTab = _cartUtils$cartState.activeTab,
      isLoading = _cartUtils$cartState.isLoading,
      isShowDetail = _cartUtils$cartState.isShowDetail,
      selectList = _cartUtils$cartState.selectList,
      addressInfo = _cartUtils$cartState.addressInfo,
      ACTIVE_NAME = _cartUtils$cartState.ACTIVE_NAME,
      isManagement = _cartUtils$cartState.isManagement,
      freeShipping = _cartUtils$cartState.freeShipping,
      totalPricesStyle = _cartUtils$cartState.totalPricesStyle,
      calculatedAllPrice = _cartUtils$cartState.calculatedAllPrice,
      selectProductCount = _cartUtils$cartState.selectProductCount,
      isHiddenBottomArea = _cartUtils$cartState.isHiddenBottomArea,
      isCreatePurchaseError = _cartUtils$cartState.isCreatePurchaseError;
    var _cartUtils$handleCart = cartUtils.handleCartState,
      onCheckAll = _cartUtils$handleCart.onCheckAll,
      getAndUpdateData = _cartUtils$handleCart.getAndUpdateData,
      getOrderDetailList = _cartUtils$handleCart.getOrderDetailList,
      isOutOfStockOrSoldOut = _cartUtils$handleCart.isOutOfStockOrSoldOut;
    var onShowDiscountDetails = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$Bridge$callFnV, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Bridge.callFnVal('isAuthenticated', {})['catch'](() => ({
                result: false
              }));
            case 2:
              _yield$Bridge$callFnV = _context.sent;
              result = _yield$Bridge$callFnV.result;
              if (result) {
                _context.next = 7;
                break;
              }
              Bridge.callFn('startLogin', {}, () => {});
              return _context.abrupt("return");
            case 7:
              if (addressInfo.value) {
                _context.next = 10;
                break;
              }
              showToast({
                message: t('modules.cart.PLEASE_FILL_IN_THE_ADDRESS_FIRSTLY'),
                className: 'a-toast'
              });
              return _context.abrupt("return");
            case 10:
              if (!(calculatedAllPrice.value.totalAmount === 0)) {
                _context.next = 13;
                break;
              }
              _context.next = 13;
              return getOrderDetailList();
            case 13:
              isShowDetail.value = !isShowDetail.value;
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function onShowDiscountDetails() {
        return _ref.apply(this, arguments);
      };
    }();
    var goToPay = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var list;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              selectList.value.forEach(item => {
                awsRumHandler.recordClickEvent(_objectSpread(_objectSpread({}, clickEvents.cartPage.checkout_btn), {}, {
                  asinid: item.asin
                }));
              });
              if (selectList.value.length) {
                _context2.next = 4;
                break;
              }
              showToast({
                message: t('modules.cart.NOT_SELECT_PRODUCT'),
                className: 'a-toast'
              });
              return _context2.abrupt("return");
            case 4:
              if (!isCreatePurchaseError.value) {
                _context2.next = 7;
                break;
              }
              showToast({
                message: t('modules.cart.CART_EXCEEDED'),
                className: 'a-toast'
              });
              return _context2.abrupt("return");
            case 7:
              _context2.next = 9;
              return isLoginAuthenticated();
            case 9:
              if (_context2.sent) {
                _context2.next = 11;
                break;
              }
              return _context2.abrupt("return");
            case 11:
              list = selectList.value.filter(item => !isOutOfStockOrSoldOut(item)).map(item => {
                return {
                  asin: item.asin,
                  count: item.count,
                  merchantId: item.merchantId,
                  associateToken: item.associateToken,
                  associateTokenTimeStamp: item.associateTokenTimeStamp
                };
              });
              isLoading.value = true;
              setCheckoutList(list, ({
                isOutOfStock,
                asinList
              }) => {
                isLoading.value = false;
                if (isOutOfStock) {
                  outOfStockPopConfig.value.isShow = true;
                  outOfStockPopConfig.value.asinList = asinList;
                  return;
                }
                store.commit('checkout/setIsNewCustomerGuidePopupOpened', false);
                isHiddenBottomArea.value = true;
                router.push({
                  name: 'orderConfirm',
                  params: {
                    from: 'cart'
                  }
                });
              });
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function goToPay() {
        return _ref2.apply(this, arguments);
      };
    }();

    // Delete all products
    var onDeleteAllProducts = () => {
      var asins = selectList.value.map(item => item.asin);
      Bridge.callFn('deleteShoppingCartList', {
        asins
      }, () => {
        asins.forEach(asinItem => {
          var index = cartData.value.findIndex(item => item.asin === asinItem);
          cartData.value.splice(index, 1);
        });
        // Mark the shopping cart data change status every time there is a change in the shopping cart data
        setCartDataChangeStatus(true);
        showToast({
          message: t('modules.cart.DELETE_SUCCESSFULLY'),
          icon: SUCCESS_ICON_IMAGE_URL,
          overlay: false,
          overlayClass: 'a-overlay-white',
          className: 'a-toast'
        });
      });
    };
    __expose({
      element: totalPricesRef
    });
    return (_ctx, _cache) => {
      var _component_van_checkbox = _resolveComponent("van-checkbox");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: "total-prices",
        ref_key: "totalPricesRef",
        ref: totalPricesRef,
        style: _normalizeStyle(_unref(totalPricesStyle))
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_checkbox, {
        class: "radio",
        modelValue: _unref(selectAll),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(selectAll) ? selectAll.value = $event : null),
        "checked-color": "#eb1745",
        onClick: _cache[1] || (_cache[1] = $event => {
          {
            _unref(onCheckAll)(), isShowDetail.value = false;
          }
        })
      }, {
        icon: _withCtx(checkboxProps => [_createElementVNode("img", {
          src: checkboxProps.checked ? _unref(SELECTED) : _unref(NOT_SELECTED)
        }, null, 8, _hoisted_2)]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('common.selectAll')), 1)])]), !_unref(isManagement) && _unref(activeTab) !== _unref(ACTIVE_NAME).ALREADY_SOLD_OUT ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("p", null, [_createElementVNode("label", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('modules.cart.SUB_TOTAL')), 1)]), _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('common.currencyUnit')), 1), _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(priceSplice)(_unref(calculatedAllPrice).totalAmount)[0]), 1), _createElementVNode("span", _hoisted_9, "." + _toDisplayString(_unref(priceSplice)(_unref(calculatedAllPrice).totalAmount)[1]), 1)]), _unref(freeShipping).isFreeShipping && _unref(calculatedAllPrice).totalAmount && _unref(addressInfo) ? (_openBlock(), _createElementBlock("p", {
        key: 0,
        onClick: onShowDiscountDetails,
        style: {
          "font-size": "3.2vw",
          "zoom": "0.84",
          "margin-right": "5px",
          "margin-top": "2px"
        }
      }, [_unref(calculatedAllPrice).discount > 0 ? (_openBlock(), _createElementBlock("label", _hoisted_10, [_createTextVNode(_toDisplayString(_ctx.$t('modules.cart.PROMOTIONAL_DEDUCTION')) + " ", 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.currencyUnit') + _unref(calculatedAllPrice).discount), 1)])) : _createCommentVNode("", true), _unref(calculatedAllPrice).shippingDiscount > 0 ? (_openBlock(), _createElementBlock("label", _hoisted_11, [_createTextVNode("  " + _toDisplayString(_ctx.$t('modules.cart.SHIPPING_FEE_SAVING')) + " ", 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.currencyUnit') + _unref(calculatedAllPrice).shippingDiscount), 1)])) : _createCommentVNode("", true), _createElementVNode("img", {
        class: "uparrow",
        src: _unref(UPARROW),
        alt: ""
      }, null, 8, _hoisted_12)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("button", {
        class: "button -primary",
        onClick: goToPay
      }, [_createElementVNode("div", _hoisted_14, [_createTextVNode(_toDisplayString(_ctx.$t('button.GO_TO_CHECKOUT')) + " ", 1), _createElementVNode("span", _hoisted_15, _toDisplayString(`(${_unref(selectProductCount)})`), 1)])])])])) : (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("button", {
        class: "button -primary",
        onClick: onDeleteAllProducts,
        disabled: !_unref(selectList).length
      }, [_createTextVNode(_toDisplayString(_ctx.$t('button.DELETE')) + " ", 1), _createElementVNode("span", _hoisted_18, _toDisplayString(`(${_unref(selectList).length})`), 1)], 8, _hoisted_17)]))], 4), _createVNode(OutOfStockPopup, {
        isShow: outOfStockPopConfig.value.isShow,
        "onUpdate:isShow": _cache[2] || (_cache[2] = $event => outOfStockPopConfig.value.isShow = $event),
        asinList: outOfStockPopConfig.value.asinList,
        onConfirm: _unref(getAndUpdateData)
      }, null, 8, ["isShow", "asinList", "onConfirm"])], 64);
    };
  }
};